import { z } from 'zod';
import { ESTADOS_CIVILES, ESCOLARIDADES, SEXOS } from '../catalogos/clinico.js';
import { esquemaMotivo } from './comunes.js';
/** Fecha sin hora, en formato ISO corto. Se guarda tal cual para evitar el
 * clasico corrimiento de un dia al cruzar zonas horarias. */
export const esquemaFechaSolo = z
    .string()
    .trim()
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'Use el formato AAAA-MM-DD')
    .refine((valor) => !Number.isNaN(Date.parse(`${valor}T12:00:00Z`)), 'Fecha inválida');
const esquemaContactoEmergencia = z.object({
    nombre: z.string().trim().max(120).default(''),
    parentesco: z.string().trim().max(60).default(''),
    telefono: z.string().trim().max(40).default(''),
});
export const esquemaCrearPaciente = z.object({
    nombre: z.string().trim().min(2, 'Escriba el nombre').max(80),
    apellidoPaterno: z.string().trim().max(80).default(''),
    apellidoMaterno: z.string().trim().max(80).default(''),
    sexo: z.enum(SEXOS).default('Femenino'),
    fechaNacimiento: esquemaFechaSolo,
    estadoCivil: z.enum(ESTADOS_CIVILES).optional(),
    escolaridad: z.enum(ESCOLARIDADES).optional(),
    ocupacion: z.string().trim().max(120).default(''),
    telefono: z.string().trim().max(40).default(''),
    correo: z.union([z.literal(''), z.string().trim().toLowerCase().email()]).default(''),
    domicilio: z.string().trim().max(240).default(''),
    contactoEmergencia: esquemaContactoEmergencia.default({}),
    alergias: z.string().trim().max(500).default(''),
    notasAdministrativas: z.string().trim().max(1000).default(''),
});
export const esquemaActualizarPaciente = esquemaCrearPaciente.partial();
export const esquemaBusquedaPacientes = z.object({
    texto: z.string().trim().max(120).optional(),
    pagina: z.coerce.number().int().min(1).default(1),
    porPagina: z.coerce.number().int().min(1).max(100).default(20),
});
/**
 * Edad cumplida a partir de una fecha en formato AAAA-MM-DD.
 *
 * Se calcula y no se guarda: una edad almacenada queda desactualizada al dia
 * siguiente, y en un expediente clinico eso importa.
 */
export function edadEnAnios(fechaNacimiento, hoy = new Date()) {
    const partes = fechaNacimiento.split('-').map(Number);
    const anio = partes[0] ?? 0;
    const mes = partes[1] ?? 1;
    const dia = partes[2] ?? 1;
    let edad = hoy.getFullYear() - anio;
    const cumpleEsteAnio = hoy.getMonth() + 1 > mes || (hoy.getMonth() + 1 === mes && hoy.getDate() >= dia);
    if (!cumpleEsteAnio)
        edad -= 1;
    return Math.max(0, edad);
}
export function nombreCompletoDe(paciente) {
    return [paciente.nombre, paciente.apellidoPaterno, paciente.apellidoMaterno]
        .filter(Boolean)
        .join(' ')
        .trim();
}
/** Dar de baja a una paciente exige decir por que (FIND-017). */
export const esquemaBajaPaciente = z.object({ motivo: esquemaMotivo });
//# sourceMappingURL=paciente.js.map